<template lang="pug">
.m-card
  .m-card-header(:id="'heading-htftcs-' + id" :data-bs-target="'#collapse-htftcs-' + id" :aria-controls="'collapse-htftcs-' + id" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ $t("m.BT_CSHTFT") }}
  .m-card-body.collapse.show(:id="'collapse-htftcs-' + id" :aria-labelledby="'heading-htftcs-' + id" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .market-card-filter 
          .score-dropdown-wrapper
            .score-dropdown.dropdown
              .btn-dropdown(:id="'score-dropdown-btn-htcs-' + id" data-bs-toggle='dropdown' aria-haspopup='true' aria-expanded='false')
                | HT {{ ht }}
              .dropdown-menu.score-dropdown-menu(:data-bs-labelledby="'score-dropdown-btn-htcs-' + id")
                ul
                  li(v-for="(item, index) in htKeys")
                    a.dropdown-item(@click="selectHalfTime(item)") {{ item }}
            .score-dropdown.dropdown
              .btn-dropdown(:id="'score-dropdown-btn-ftcs-' + id" data-bs-toggle='dropdown' aria-haspopup='true' aria-expanded='false')
                | FT {{ CSHTFTX[ft] }}
              .dropdown-menu.score-dropdown-menu(v-if="moreItems['cshtfto'][ht] && moreItems['cshtfto'][ht][78] && moreItems['cshtfto'][ht][78].length > 0" :data-bs-labelledby="'score-dropdown-btn-ftcs-' + id")
                ul
                  li(v-for="(item, index) in moreItems['cshtfto'][ht][78]")
                    a.dropdown-item(@click="selectFullTime(item)") {{ CSHTFTX[item] }}
            oddsColumnItem(:odds="moreItems['cshtfto'][ht]" :idx="ft" :typ="oddsType")
          .view-all-btn.collapsed(data-bs-toggle='collapse' :href="'#cs-htft-' + id" role='button' aria-expanded='false' :aria-controls="'cs-htft-' + id") {{ $t("ui.all") }}
        .odds-wrapper.collapse(:id="'cs-htft-' + id")
          .odds-group
            .three-col
              template(v-for="(i,n) in ftKeys")
                template(v-if="!scores.running.includes(i)")
                  template(v-for="j in moreItems['cshtfto'][i][78]")
                    .odd-box
                      .odd-point
                        span.ha {{ i }} /  {{ CSHTFTX[j] }}
                      oddsColumnItem.odd-value(:odds="moreItems['cshtfto'][i]" :idx="j" :typ="oddsType")


//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-cshtft-' + id"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-cshtft-' + id"
//-     :aria-controls="'collapse-cshtft-' + id"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $t("m.BT_CSHTFT") }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-cshtft-' + id"
//-     :id="'collapse-cshtft-' + id"
//-   )
//-     .card-body.p-0
//-       //- small.text-dark {{ Object.keys(moreItems['cshtfto']) }}
//-       //- small.text-danger {{ scores.running }}
//-       .market-card-content
//-         .three-column
//-           .three-column-title
//-             .market-card-filter
//-               .score-dropdown-wrapper
//-                 .score-dropdown
//-                   button#score-dropdown-btn.dropdown-btn(type='button' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false')
//-                     | HT {{ ht }}
//-                   .dropdown-menu(aria-labelledby='score-dropdown-btn')
//-                     a.dropdown-item(@click="selectHalfTime(item)" v-for="(item, index) in htKeys") {{ item }}
//-                 .score-dropdown
//-                   button#score-dropdown-btn.dropdown-btn(type='button' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false')
//-                     | FT {{ CSHTFTX[ft] }}
//-                   .dropdown-menu(v-if="moreItems['cshtfto'][ht] && moreItems['cshtfto'][ht][78] && moreItems['cshtfto'][ht][78].length > 0" aria-labelledby='score-dropdown-btn')
//-                     template(v-if="ht")
//-                       a.dropdown-item(@click="selectFullTime(item)" v-for="(item, index) in moreItems['cshtfto'][ht][78]") {{ CSHTFTX[item] }}
//-                 oddsColumnItem(:odds="moreItems['cshtfto'][ht]" :idx="ft" :typ="oddsType")
//-               .view-all-btn.collapsed(data-toggle='collapse' href='#cs-htft' role='button' aria-expanded='false' aria-controls='cs-htft') {{ $t("ui.all") }}
//-           #cs-htft.correct-score-three-column.collapse
//-             .three-column-group
//-               template(v-for="(i,n) in ftKeys")
//-                 template(v-if="!scores.running.includes(i)")
//-                   .three-column-odd-area(v-for="j in moreItems['cshtfto'][i][78]")
//-                     .three-column-odd-area-oddtype
//-                       p.mb-0 {{ i }} /  {{ CSHTFTX[j] }}
//-                     .three-column-odd-area-group
//-                       .odd-box
//-                         .odd
//-                           oddsColumnItem.odd-value(:odds="moreItems['cshtfto'][i]" :idx="j" :typ="oddsType")
</template>

<script>
import config from "@/config";
import oddsColumnItem from "@/components/mobile/main/xitem/oddsColumnItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    oddsColumnItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  },
  data() {
    return {
      view_all: false,
      ht: null,
      ft: null,
    }
  },
  computed: {
    oddsType() {
      return this.$store.getters.pageDisplay.oddsType;
    },
    htKeys() {
      var A = this.scores.running;
      var B = Object.keys(this.moreItems['cshtfto']);

      const ASet = new Set(A);
      const result = [];
      for (let i = 0; i < B.length; i++) {
        if (!ASet.has(B[i])) {
          result.push(B[i]);
        }
      }

      return result;
    },
    ftKeys() {
      return Object.keys(this.moreItems['cshtfto']);
    },
    CSHTFTX() {
      return config.CSHTFTX;
    },
    match() {
      return this.$store.getters.data.match[this.matchId];
    },
    scores() {
      var home_score = -1;
      var away_score = -1;
      var score = this.match[11];

      if (score && score.trim() !== "") {
        var result = score.split(" - ");
        if (result.length === 2) {
          home_score = isNaN(parseInt(result[0].trim(), 10)) ? -1 : parseInt(result[0].trim(), 10);
          away_score = isNaN(parseInt(result[1].trim(), 10)) ? -1 : parseInt(result[1].trim(), 10);
        }
      }

      // console.log(home_score, away_score);

      var running = [];
      const t = config.CSHTFTX;

      for (var t1 = 0; t1 < t.length; t1++) {
        var t2 = t[t1].split("-");
        if (t2.length === 2) {
          var th = isNaN(parseInt(t2[0].trim(), 10)) ? -1 : parseInt(t2[0].trim(), 10);
          var ta = isNaN(parseInt(t2[1].trim(), 10)) ? -1 : parseInt(t2[1].trim(), 10);
          if (th < home_score) {
            running.push(t[t1]);
          } else {
            if (th == home_score && ta < away_score) {
              running.push(t[t1]);
            }
          }
        }
      }

      var r = {
        home_score,
        away_score,
        running,
      };

      // console.log(r);

      return r;
    },
  },
  mounted() {
    this.selectHalfTime(this.htKeys[0]);
  },
  methods: {
    toggleViewAll() {
      this.view_all = !this.view_all;
    },
    selectHalfTime(e) {
      this.ht = e;
      this.ft = this.moreItems['cshtfto'][this.ht][78][0];
    },
    selectFullTime(e) {
      this.ft = e;
    },
  },
}
</script>
